/* 2D/3D PDP: insert the free shipping note above the APO Next Step row. */
(function () {
  'use strict';

  if (window.__lpFreeShippingNoteInit) return;
  window.__lpFreeShippingNoteInit = true;

  var NOTE_CLASS = 'lp-free-shipping-note';
  var ROW_SELECTOR = '.mw-group__button';
  var script = document.currentScript || document.querySelector('script[data-lp-free-shipping-scope]');
  var scopeSelector = script && script.getAttribute('data-lp-free-shipping-scope');
  var scheduled = false;

  function getRoot() {
    if (scopeSelector) {
      var scoped = document.querySelector(scopeSelector);
      if (scoped) return scoped;
    }
    return document.querySelector('[id^="MainProduct-"]') || document.body;
  }

  function isButtonRow(node) {
    return !!(node && node.classList && node.classList.contains('mw-group__button'));
  }

  function isNote(node) {
    return !!(node && node.classList && node.classList.contains(NOTE_CLASS));
  }

  function findDiscountWidget(parent) {
    var discount = null;
    Array.prototype.forEach.call(parent.children, function (child) {
      if (!discount && child.hasAttribute && child.hasAttribute('data-lp-discount-widget')) {
        discount = child;
      }
    });
    return discount;
  }

  function findKeptNote(parent, row) {
    var kept = null;
    Array.prototype.forEach.call(parent.children, function (child) {
      if (!isNote(child)) return;
      if (!kept && (child.compareDocumentPosition(row) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        kept = child;
      } else {
        child.remove();
      }
    });
    return kept;
  }

  function cleanupStrayNotes(root) {
    root.querySelectorAll('.' + NOTE_CLASS).forEach(function (note) {
      var next = note.nextElementSibling;
      while (next) {
        if (isButtonRow(next)) return;
        next = next.nextElementSibling;
      }
      note.remove();
    });
  }

  function buildNote() {
    var note = document.createElement('p');
    note.className = NOTE_CLASS;
    note.appendChild(document.createTextNode("Congrats! You've earned "));
    var strong = document.createElement('strong');
    strong.textContent = 'FREE SHIPPING';
    note.appendChild(strong);
    return note;
  }

  function enhance() {
    scheduled = false;
    var root = getRoot();
    if (!root) return;

    cleanupStrayNotes(root);

    root.querySelectorAll(ROW_SELECTOR).forEach(function (row) {
      if (row.closest('.mw-tingle')) return;
      var parent = row.parentElement;
      if (!parent) return;

      var discount = findDiscountWidget(parent);
      var note = findKeptNote(parent, row);

      if (note) {
        if (discount && (note.compareDocumentPosition(discount) & Node.DOCUMENT_POSITION_PRECEDING)) {
          parent.insertBefore(note, discount);
        }
        return;
      }

      parent.insertBefore(buildNote(), discount || row);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(enhance);
    } else {
      window.setTimeout(enhance, 16);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  try {
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  } catch (e) {}

  window.setInterval(schedule, 1500);
})();
